import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";

const SOCIALS = [
  { key: "instagram", label: "Instagram" },
  { key: "linkedin", label: "LinkedIn" },
  { key: "pinterest", label: "Pinterest" },
  { key: "facebook", label: "Facebook" },
  { key: "youtube", label: "YouTube" },
  { key: "whatsapp", label: "WhatsApp" },
];

export default function Footer() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="bg-[#181816] text-[#F5F3EF] border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 pt-24 pb-12">
        <Link to="/" data-testid="footer-brand" className="block">
          <h2 className="font-serif text-[11vw] sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight">
            SPACE ARTS <em className="italic text-[#8A857D]">by Ak</em>
          </h2>
        </Link>

        <div className="mt-16 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#8A857D]">Navigate</p>
            <div className="mt-5 flex flex-col gap-3">
              {[["Projects", "/projects"], ["Services", "/services"], ["About", "/about"], ["Contact", "/contact"]].map(([label, to]) => (
                <Link key={to} to={to} data-testid={`footer-link-${label.toLowerCase()}`} className="link-underline w-fit font-light text-[#D6D2C9] hover:text-white transition-colors">
                  {label}
                </Link>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#8A857D]">Follow the studio</p>
            <div className="mt-5 flex flex-col gap-3" data-testid="footer-socials">
              {SOCIALS.filter((s) => settings?.[s.key]).map((s) => (
                <a
                  key={s.key}
                  href={settings[s.key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${s.key}`}
                  className="group w-fit inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-[#D6D2C9] hover:text-white transition-colors"
                >
                  {s.label}
                  <ArrowUpRight className="h-3 w-3 opacity-40 group-hover:opacity-100 transition-opacity" />
                </a>
              ))}
              {settings && SOCIALS.every((s) => !settings[s.key]) && (
                <p className="text-sm text-[#8A857D] font-light">Social links can be added in the Studio Dashboard.</p>
              )}
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#8A857D]">Write to the studio</p>
            <div className="mt-5 flex flex-col gap-3 font-light text-[#D6D2C9]">
              {settings?.email && <a href={`mailto:${settings.email}`} data-testid="footer-email" className="link-underline w-fit hover:text-white transition-colors">{settings.email}</a>}
              {settings?.phone && <span data-testid="footer-phone">{settings.phone}</span>}
              {settings?.address && <span data-testid="footer-address" className="text-sm text-[#8A857D]">{settings.address}</span>}
              <Link to="/contact" data-testid="footer-cta" className="mt-4 w-fit inline-flex items-center gap-2 border border-white/25 px-5 py-3 font-mono text-[11px] uppercase tracking-[0.22em] hover:bg-[#F8F6F0] hover:text-[#181816] transition-colors duration-300">
                Start an Inquiry <ArrowUpRight className="h-3.5 w-3.5" />
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.22em] text-[#8A857D]">
          <span>© 2026 Space Arts by Ak</span>
          <span>Crafted in stillness</span>
        </div>
      </div>
    </footer>
  );
}
